import { render, staticRenderFns } from "./MixinDB.vue?vue&type=template&id=c97244f0&scoped=true&lang=html&"
import script from "./MixinDB.vue?vue&type=script&lang=js&"
export * from "./MixinDB.vue?vue&type=script&lang=js&"
import style0 from "./MixinDB.vue?vue&type=style&index=0&id=c97244f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97244f0",
  null
  
)

export default component.exports